// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {defineStore} from 'pinia'
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {SanitizeValue} from "@/core/utils";


export const usePaginationStore = defineStore('PaginationStore', {
  state: () => {
    return {
      page: 0,
      totalPage: null,
    }
  },
  getters: {
    getActualPageToDisplay(state) {
      return state.page + 1
    },
    getNextPage(state) {
      return state.page + 1
    },
    getActualPage(state) {
      return state.page
    },
    getPreviousPage(state) {
      return state.page - 1
    },
    getIndexStart(state) {
      return Math.max(0, state.page - 2)
    },
    getIndexEnd(state) {
      return Math.min(state.page + 2, state.totalPage)
    },
    getPages() {
      const pagesArray = []
      for (let i = this.getIndexStart; i < this.getIndexEnd; i++) {
        pagesArray.push(i + 1)
      }
      return pagesArray
    },
    
    getTotalPage(state) {
      return state.totalPage
    },
    
    
  },
  actions: {
    getSelectedPageFromUrl(): number {
      const urlParams = useUrlStore().decomposeUrl().searchParams
      const pageParam = urlParams.get('p')
      return SanitizeValue(pageParam )|| 0
    },
    
    resetPageInUrl(url = null): number {
      if (!url) {
        url = useUrlStore().decomposeUrl()
      }
      url.searchParams.delete('p')
      useUrlStore().updateUrl(url)
    },
    
    setActualPageValue(newPage: number) {
      const serpStore = useSerpResultsStore();
      const urlStore = useUrlStore();
      
      this.page = newPage
      urlStore.updatePageParameter(newPage)
      serpStore.scrollIntoView()
    },
    resetPageValue(url: URL | null = null) {
      this.resetPageInUrl(url)
      this.page = 0
    }
  }
})
